import React, { FC, useState, useEffect, useMemo } from 'react';
import { RouteComponentProps, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import { CandidateSurveyDetail, SurveyFormMode } from 'src/app/modules/Survey/types/survey-types';
import { fetchCandidateSurveyItem } from '../../../network/surveyCrud';
import CandidateSurveyDetailForm from './components/CandidateSurveyDetailForm';
import { LayoutSplashScreen } from 'src/app/layout';

const CandidateSurveyDetailPage: FC<RouteComponentProps> = ({ history }) => {
  const { id } = useParams<{ id: string }>();
  const { formMode, code } = useMemo(
    () => ({
      formMode: id ? SurveyFormMode.EDIT : SurveyFormMode.CREATE,
      code: id ? id : undefined,
    }),
    [id],
  );

  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [surveyDetail, setSurveyDetail] = useState<CandidateSurveyDetail>();

  const reloadData = () => {
    if (code) {
      setIsLoading(true);
      fetchCandidateSurveyItem(code, dispatch)
        .then((result) => {
          setSurveyDetail(result);
        })
        .catch(() => {
          history.push(NOT_FOUND_ERROR_PAGE_PATH);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    reloadData();
    // eslint-disable-next-line
  }, [code]);

  return (
    <>
      {formMode === SurveyFormMode.CREATE && (
        <>
          <CandidateSurveyDetailForm formMode={formMode} />
        </>
      )}
      {formMode === SurveyFormMode.EDIT &&
        (isLoading || !surveyDetail ? (
          <LayoutSplashScreen />
        ) : (
          <>
            <CandidateSurveyDetailForm formMode={formMode} surveyDetail={surveyDetail} />
          </>
        ))}
    </>
  );
};

export default CandidateSurveyDetailPage;
